import type { FC, ReactNode } from 'react'
import NextLink from 'next/link'
import type { TypeHref } from '@/schema'

type Props = {
  href: TypeHref,
  // arialabel: string,
  ariaDisabled?: boolean,
  rel?: 'alternate' | 'author' | 'bookmark' | 'help' | 'license' | 'me' | 'next' | 'prev' | 'search' | 'tag',
  locale?: string,
  title?: string,
  className?: string
  children: ReactNode
}

export const Link:FC<Props> = ({ href, children, ariaDisabled, rel, locale, title, className }) => {
  return (
    <NextLink href={href} passHref {...locale && { locale }} {...rel && { rel }} {...ariaDisabled && { 'aria-disabled': ariaDisabled }} {...title && { title }} {...className && { className }}>
      {children}
    </NextLink>
  )
}
